import Nullstack from 'nullstack';
export default function IconGeometry({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-geometry",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 21l4 -12m2 0l1.48 4.439m.949 2.847l1.571 4.714"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "7",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M4 12c1.526 2.955 4.588 5 8 5c3.41 0 6.473 -2.048 8 -5"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v-2"
  }), " ");
}